import React from 'react';
import { usePNFTranslation } from 'src/common/helpers';

interface NavFooterProps {
  footerLinks: Record<string, string>;
}
const NavFooter: React.FC<NavFooterProps> = ({ footerLinks }) => {
  const t = usePNFTranslation();

  return (
    <div className="navLeftFooter nav-sprite-v1" id="navFooter">
      <div className="navFooterLine navFooterLinkLine navFooterPadItemLine navFooterCopyright">
        <ul>
          {Object.entries(footerLinks).map(([key, value]) => (
            <li key={key}>
              <a className="nav-a" href={value}>
                {t(`pnf_${key}`)}
              </a>
            </li>
          ))}
        </ul>
        <span>{t('pnf_nav_foot_copyright')}</span>
      </div>
    </div>
  );
};
export default NavFooter;
